module.exports = __webpack_public_path__ + "img/user-icon.a2442e9c.svg";